import BusinessIcon from '@mui/icons-material/Business';
import { Box, Link, Typography } from '@mui/material';
import { ConditionalLoader, Section } from 'dashboard409a/pages/Operations/components';
import Avatar from 'dashboard409a/pages/Operations/components/Avatar/Avatar';
import { CategoryBadge, ContactSection, Container, HeaderRow, InfoRow, StyledLinkSpan } from './ValuedEntity.styles';
import { ValuedEntityProps } from './ValuedEntity.types';

const ValuedEntity = ({ valuedEntity, isLoading }: ValuedEntityProps) => (
  <Section title="Valued Entity">
    <Container>
      <HeaderRow id="company-name">
        <BusinessIcon color="primary" fontSize="small" />
        <ConditionalLoader isLoading={isLoading}>
          {valuedEntity?.companyUrl ? (
            <Link
              href={valuedEntity.companyUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <StyledLinkSpan>{valuedEntity.companyName || '-'}</StyledLinkSpan>
            </Link>
          ) : (
            <StyledLinkSpan>{valuedEntity?.companyName || '-'}</StyledLinkSpan>
          )}
        </ConditionalLoader>
      </HeaderRow>
      {valuedEntity?.valuedEntityNotice && (
        <span>NOTICE: {valuedEntity.valuedEntityNotice}</span>
      )}
      <InfoRow>
        <ContactSection>
          <Typography id="primary-contact" variant="body2" color="text.secondary">
              Primary Contact:
          </Typography>
          <ConditionalLoader isLoading={isLoading} width={200}>
            <Typography fontWeight="bold">{valuedEntity?.primaryContact || '-'}</Typography>
          </ConditionalLoader>
          {valuedEntity?.primaryContactNotice && (
            <span>NOTICE: {valuedEntity.primaryContactNotice}</span>
          )}
          <Typography id="category" variant="body2" color="text.secondary" mt={1}>
              Category:
          </Typography>
          <ConditionalLoader isLoading={isLoading} width={200}>
            <CategoryBadge>{valuedEntity?.category || '-'}</CategoryBadge>
          </ConditionalLoader>
        </ContactSection>
        {valuedEntity?.salesRep && (
          <Box>
            <Typography variant="body2" color="text.secondary" mb={0.5}>
              Sales Rep:
            </Typography>
            <Avatar
              src={valuedEntity.salesRepImageSrc || ''}
              name={valuedEntity.salesRep}
              roleTitle="Sales Rep"
              isLoading={isLoading}
            />
          </Box>
        )}  
      </InfoRow>
    </Container>
  </Section>
);

export default ValuedEntity;
